var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8319 20.5H4.79624C4.08035 20.5 3.5 19.7751 3.5 18.881V8.7619C3.5 5.85584 5.38613 3.5 7.71279 3.5H18.4179M9.10227 15.1198V17.7726M6.78409 15.0357H11.4205M7.17045 12.8095H11.0341M18.9545 3.5C17.1263 3.5 15.4773 5.63229 15.4773 8.7619V20.5H18.9545C19.8081 20.5 20.5 19.7751 20.5 18.881V5.11905C20.5 4.22487 19.8081 3.5 18.9545 3.5ZM6.97727 7.54762H11.6136C12.2538 7.54762 12.7727 8.09127 12.7727 8.7619C12.7727 9.43254 12.2538 9.97619 11.6136 9.97619H6.97727C6.33712 9.97619 5.81818 9.43254 5.81818 8.7619C5.81818 8.09127 6.33712 7.54762 6.97727 7.54762Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.6194a98df89eb53d01d22e3daf2f4849.svg";
export { ForwardRef as ReactComponent };